import  { Dayjs } from "dayjs";

import { useSelectedDate } from "../../../shared/hooks/use-selected-date";
import { TableCell } from "./table-cell/table-cell";
import { TableDaysRow } from "./table-days-row/table-days-row";
import { StyledGrid, StyledTable } from "./table.style";

export const Table = () => {
  const selectedDate: Dayjs = useSelectedDate();

  const selectedMonthArray: Dayjs[] = getSelectedMonthArray(selectedDate);

  return (
    <StyledTable>
      <TableDaysRow />
      <StyledGrid>
        {selectedMonthArray.map((date, index) => (
          <TableCell key={index} date={date} />
        ))}
      </StyledGrid>
    </StyledTable>
  );
};

const getSelectedMonthArray = (selectedDate: Dayjs): Dayjs[] => {
  const firstDateOfMonth = selectedDate.startOf("month");
  const firstDayOfMonth = getLocalDay(firstDateOfMonth);

  const daysInMonth = selectedDate.daysInMonth();

  const lastDateOfMonth = selectedDate.endOf("month");
  const lastDayOfMonth = getLocalDay(lastDateOfMonth);

  const lastDateOfPrevMonth = lastDateOfMonth
    .subtract(1, "month")
    .endOf("month");

  let selectedMonthArray: Dayjs[] = [];

  for (let i = firstDayOfMonth; i > 0; i--) {
    selectedMonthArray.push(lastDateOfPrevMonth.subtract(i - 1, "day"));
  }

  for (let i = 0; i < daysInMonth; i++) {
    selectedMonthArray.push(firstDateOfMonth.add(i, "day"));
  }

  for (let i = lastDayOfMonth; i < 6; i++) {
    selectedMonthArray.push(lastDateOfMonth.add(i - lastDayOfMonth + 1, "day"));
  }

  while (true) {
    let len = selectedMonthArray.length;

    if (len >= 41) {
      break;
    } else {
      const lastDateOfArray = selectedMonthArray[len - 1];

      for (let i = 1; i <= 7; i++) {
        selectedMonthArray.push(lastDateOfArray.add(i, "day"));
      }
    }
  }

  return selectedMonthArray;
};

const getLocalDay = (date: Dayjs): number => {
  const day = date.day();

  return day !== 0 ? day - 1 : 6;
};
